import { Submittal } from '.'
import { NotificationEventItem } from '../NotificationEventItem'
import { ComplexEnumItem } from '../../../utils/complexEnum/ComplexEnumItem'

/**
 * generates a common NotificationEventItem for edited notification events
 *
 * the key for this NotificationEventItem should be `Edited`
 *
 * ---
 *
 * the name is: Edited
 *
 * the description is: Any `{editable}` field is edited outside the normal workflow
 *
 * @param options {@link EditedOptions}
 * @see {@link NotificationEventItem}
 */
export function EditedNotificationEventItem<ID extends Lowercase<string>>({
  id,
  editable,
}: EditedOptions<ID>) {
  return new NotificationEventItem({
    id,
    name: 'Edited',
    description: `Any ${editable} field is edited outside of the normal workflow`,
  })
}

type EditedOptions<T extends Lowercase<string>> = Pick<
  ComplexEnumItem<T>,
  'id'
> & {
  /**
   * which editable object this is for
   */
  editable:
    | Submittal
    | 'Field Design Change'
    | 'Request For Information'
    | 'Identified Field Issue'
    | 'Issue'
}
